import { render, staticRenderFns } from "./InfoBien.vue?vue&type=template&id=05fe107e&"
import script from "./InfoBien.vue?vue&type=script&lang=js&"
export * from "./InfoBien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports